import '../styles/mood-card.css'
import MoodSlider from './MoodSlider'

const MoodCard = ({ mood, icon, value, onSliderChange, activeMood, setActiveMood }) => {
  const isActive = activeMood === mood

  return (
    <article 
      className={`mood-card ${isActive ? 'active' : ''}`}
      onClick={() => setActiveMood(mood)}
    >
        <img src={icon} alt={`${mood} icon`} />
        <span>
          <h4>{mood}</h4>
        </span>
        <MoodSlider 
          mood={mood} 
          value={value}
          onChange={onSliderChange}
        />
    </article>
  )
}

export default MoodCard